<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="21000006" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'marginBalance'">
                  <span>{{ scope.row[scope.column.property] / 100 }}</span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions
                  permpisions="2000801"
                  v-if="scope.row.expireType !== 1"
                >
                  <span class="primary cur" @click="setExpire(scope.row)"
                    >立刻到期</span
                  >
                </qx-permpisions>
                <qx-permpisions
                  permpisions=""
                  v-if="scope.row.expireType === 1"
                >
                  <span class="primary cur" @click="showLog(scope.row.flowId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  advanceList,
  advanceListSetExpire,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'busiCode', label: '流水号码', fixed: true },
          { prop: 'userName', label: '收款方' },
          { prop: 'userPhone', label: '手机号码' },
          { prop: 'driverName', label: '主驾司机' },
          { prop: 'typeName', label: '业务类型' },
          { prop: 'payTypeName', label: '费用类型' },
          { prop: 'marginBalance', label: '未到期款' },
          { prop: 'planExpireDate', label: '预计到期时间' },
          { prop: 'stateName', label: '业务状态' },
          { prop: 'reason', label: '备注' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: advanceList,
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    async setExpire (item) {
      const confirmRes = await this.$confirm('是否确认将该笔未到期资金设置为到期', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 已取消操作
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await advanceListSetExpire({
          flowId: item.flowId,
          userId: item.userId,
          signType: item.type,
          flowIds: item.flowIds,
        });
        if (!res.failed) {
          this.$message.success('设置成功');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
